export default __webpack_public_path__ + "static/media/facebook.d97c4999.svg";